import type { SeoData } from './seoData';

function upsertMeta(attr: 'name' | 'property', key: string, content: string): void {
  let el = document.head.querySelector(
    `meta[${attr}="${key}"]`,
  ) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel: string, href: string): void {
  let el = document.head.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

// Applies the resolved SEO metadata for the current route, reusing existing
// tags where possible and creating any missing ones.
export function applySeoMeta(seo: SeoData): void {
  document.title = seo.title;
  upsertMeta('name', 'description', seo.description);
  upsertMeta('name', 'keywords', seo.keywords);
  upsertLink('canonical', seo.canonical);

  upsertMeta('property', 'og:title', seo.title);
  upsertMeta('property', 'og:description', seo.description);
  upsertMeta('property', 'og:url', seo.canonical);
  upsertMeta('property', 'og:type', seo.type === 'article' ? 'article' : 'website');

  if (seo.image) {
    upsertMeta('property', 'og:image', seo.image);
    upsertMeta('name', 'twitter:image', seo.image);
  }

  upsertMeta('name', 'twitter:card', seo.image ? 'summary_large_image' : 'summary');
  upsertMeta('name', 'twitter:title', seo.title);
  upsertMeta('name', 'twitter:description', seo.description);
}